import { HttpClient, HttpEventType } from '@angular/common/http';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NzUploadChangeParam, NzUploadFile } from 'ng-zorro-antd/upload';
import { Observable, Observer } from 'rxjs';
import { NotificationType } from 'src/app/models/notification.message';
import {  DocumentModel, DocumentUploadDto } from 'src/app/models/requests/DocumentUploadDto';
import { LoginResponseData } from 'src/app/models/responses/login-response-data';
import { DocumentsService } from 'src/app/services/documents.service';
import { NotificationService } from 'src/app/services/notification.service';
import { TokenService } from 'src/app/services/token.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-employee-file-uploads',
  templateUrl: './employee-file-uploads.component.html',
  styleUrls: ['./employee-file-uploads.component.css']
})
export class EmployeeFileUploadsComponent implements OnInit {
  public progress: number=0;
  empName:string='';
  uploading = false;
  fileList: NzUploadFile[] = [];
  fileList1: NzUploadFile[] = [];
  documentList: DocumentModel[]=[];
  Documents: DocumentModel[]=[];
  id:number =0;
  base64 :string = '';
  Description:string ='';
  public message: string='';
  CanviewDocuments:boolean=false;
  CanAddDocuments:boolean=false;


  @Output() public onUploadFinished = new EventEmitter();
  constructor(private tokenService: TokenService, private notificationService:NotificationService, private http:HttpClient,  private documentService:DocumentsService,private notification: NotificationService,    private route: ActivatedRoute) { }

  ngOnInit(): void {
    debugger
    let Id= this.route.snapshot.queryParamMap.get('id');
    Id = this.route.snapshot.queryParamMap.get('id');
     this.id= parseInt(Id!);

    this. loadRecords();
    this.UserViews();
  }
async loadRecords(){

  let docs = await this.documentService.getDocumentsByEmployee(this.id).toPromise();
  this.Documents = <DocumentModel[]>docs.responseData;
}

async openDoc(id:number)
{

var url = `${environment.apiUrl}/Documents/DownloadDocument/${id}`;
window.open(url, '_blank');
  //let docs = await this.documentService.DownloadDocument(id).toPromise();

}

  beforeUpload = (file: NzUploadFile): boolean => {
    
    this.fileList = this.fileList.concat(file);


    var Doc = {} as DocumentModel;
    Doc.documentName=file.name;
    Doc.contentType=file.type!;
 
    const myReader = new FileReader();
    myReader.readAsDataURL(file as any);
    myReader.onloadend = (e) => {
      this.base64! = myReader.result!.toString();
    // console.log(myReader.result);
   //  Doc.documentContent!=myReader!.result;
    };
    this.base64! = myReader.result!.toString();
 
  
    Doc.documentContent= this.base64;
    this.documentList.push(Doc);
    console.log(this.base64);
   //console.log(Doc.documentContent);
    return false;
  };

  private getBase64(img: NzUploadFile, callback: (img: string) => void): void {
    
    const reader = new FileReader();
    reader.addEventListener('load', () => callback(reader.result!.toString()));
    reader.readAsDataURL(img.originFileObj!);
  }



  beforeUpload1 = (file: NzUploadFile) => {

    return new Observable((observer: Observer<boolean>) => {
     // const isImage = file.type?.startsWith('image');
     const validFileType = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||file.type==='application/pdf'|| file.type ==='application/msword' || file.type==='application/vnd.openxmlformats-officedocument.wordprocessingml.document';
      if (validFileType) {
      //  const isLt3M = file.size? / 1024 / 1024 < 3;
        const isLt3M = file.size! / 1024 / 1024 < 3;
        if (!isLt3M) {
      
          this.notification.sendMessage({
            message: `file must be smaller than 3MB!`,
            type: NotificationType.error
          });

          observer.complete();
          return;
        }
        this.fileList1 = this.fileList1.concat(file);
      //  this.fileList = this.fileList.concat(file); 
        observer.next(false);
        observer.complete();



      } else {
        //this.toastrService.error('You can only upload image file');
        this.notification.sendMessage({
          message: `File Not suported!`,
          type: NotificationType.error
        });
        observer.complete();
        return;
      }

    });
  }

 


  handleUpload(): void {
    const formData = new FormData();
 if(this.Description.length==0)
 { this.notification.sendMessage({
  message: `Description is mandatory!`,
  type: NotificationType.error
});

return;
}

var theDocs : DocumentModel[]=[];

  formData.append('id',this.id+"");
    this.fileList.forEach((file: any) => {
      formData.append('files[]', file);
       
    });

    
     
    let KyCFile :any =           this.fileList1[0];
    formData.append('TheFile', KyCFile, KyCFile.name);
    formData.append('Description',this.Description);
    
    
    var model = {} as DocumentUploadDto ;


    model.id = this.id;
    model.documentList=this.documentList;
        
    this.uploading = true;



    var uploadur :string= `${environment.apiUrl}/Documents/UploadEmployyeDocument`;
   
    this.http.post(uploadur, formData, {reportProgress: true, observe: 'events'})
      .subscribe(event => {
        if (event.type === HttpEventType.UploadProgress)
          this.progress = Math.round(100 * event.loaded / event.total!);
        else if (event.type === HttpEventType.Response) {
          this.message = 'Upload success.';
          this.onUploadFinished.emit(event.body);
          this.fileList1.splice(0);
          this.fileList.splice(0);
          this.uploading = false;
          this. loadRecords();
        }
      });
      this.uploading = false;
      
//no post to uploadEmployeeDocument

/*
this.documentService.uploadEmployeeDocument(model).subscribe({
  next: (data => {
    debugger
    if (data.responseCode == "00") {
      this.notification.sendMessage({
        message: data.message,
        type: NotificationType.success
      });
      this.uploading = false;
      model.documentList.splice(0);
   

    }
    else {

      this.notification.sendMessage({
        message: data.message,
        type: NotificationType.error
      });
      this.uploading = false;
    }

  }),
  error: ((error: any) => {
        
    this.uploading = false;
    this.notification.sendMessage({
      message: error.error.message,
      type: NotificationType.error
    });
  })

});

*/

 

  }
  handleChange({ file, fileList }: NzUploadChangeParam): void {
    const status = file.status;
    
   
     
    var Doc = {} as DocumentModel 
    Doc.documentName = file.name;
    Doc.contentType = file.type!; 
    
    const myReader = new FileReader();
   
    myReader.readAsDataURL(file as any);
    myReader.onloadend = (e) => {
      this.base64! = myReader.result!.toString();
    // console.log(myReader.result);
   //  Doc.documentContent!=myReader!.result;
    };

   this.documentList.push(Doc);

  
    }
  
    UserViews(): void {

      try {
  
     
        const userData: LoginResponseData = this.tokenService.getInfo();
         var UserPermission = userData.permission;
  
        const DocumentsPerm = UserPermission.find((obj) => {
          return obj.permissionName === "Documents";
        });
  
        if (DocumentsPerm) {
          
         this.CanviewDocuments=DocumentsPerm.canTerminate === true ? true : false;
        }
  
  
      }
      catch (e: unknown) { }
  
  
    }
  
  
}
